import React, {Component} from 'react';
import {connect} from 'react-redux';

import {
    Button,
    Col,
    Container,
    Progress,
    Row
} from 'reactstrap';
import {Link} from 'react-router';
import group from '../../../assets/svg/icons/group.svg';
import application from '../../../assets/svg/icons/application.svg';
import PolyUtil from "../../../util/PolyUtil";

class TenantApplicationStatus extends Component {
    content = () => {
        const {percent_complete} = this.props;

        return percent_complete < 100 ? (
            <Container className="center" fluid style={{marginTop: '4em', marginBottom: '2em'}}>
                <Row>
                    <Col>
                        <h2><strong>{percent_complete === 0 ? "Welcome to PolyRents!" : "Almost there!"}</strong></h2>
                    </Col>
                </Row>
                <hr/>
                <Row>
                    <Col xs={12} sm={6} style={{marginBottom: '1em'}}>
                        {
                            percent_complete === 0 ? (
                                <div>
                                    <h5>First Things First</h5>
                                    <p className="mb-3">Before you can start applying, there are just a couple of quick steps:</p>
                                    <Row>
                                        <Col xs={3}>
                                            <img className="pr-1" src={group} width="55px" role="presentation" />
                                        </Col>
                                        <Col xs={9}>
                                            <p className="text-lg-left mb-2">Invite all of your roommates (you can't add more after applying!)</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={3}>
                                            <img className="pr-1" src={application} width="43px" role="presentation" />
                                        </Col>
                                        <Col xs={9}>
                                            <p className="text-lg-left mb-2">Each roommate fills out their own PolyRents application.</p>
                                        </Col>
                                    </Row>
                                </div>
                            ) : (
                                <div>
                                    <h4>Application: <strong>{percent_complete}% Complete</strong></h4>
                                    <Progress value={percent_complete}/>
                                </div>
                            )
                        }
                    </Col>
                    <Col xs={12} sm={6} lg={{size: 4, offset: 1}} style={{display: 'flex', alignItems: 'center'}}>
                        <Button color="success" size="lg" block tag={Link} to="/application/">{percent_complete === 0 ? "Start your Application" : "Continue Application"}</Button>
                    </Col>
                </Row>
            </Container>
        ) : null;
    };

    render() {
        return PolyUtil.polyRender(this.props, ['percent_complete'], this.content, null);
    }
}

const mapStateToProps = (state) => ({
    percent_complete: state.tenant.application.application_percent_complete
});

export default connect(mapStateToProps)(TenantApplicationStatus);



// WEBPACK FOOTER //
// ./src/containers/tenant/dashboard/TenantApplicationStatus.js